import { sizes, spaces } from "../../groupon/foundation"
import { colors } from "./colors"

export { sizes, spaces, colors }
